import React, { ErrorInfo } from 'react';
import { loggerError } from './logger';
import { redirectToDecline } from './parent-helper';

interface IProps {
  children: React.ReactElement;
}

export default class ErrorBoundary extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
    this.state = { hasError: false };
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    loggerError(error, errorInfo);
    // console.log(error, errorInfo);
    // eslint-disable-next-line no-restricted-globals
    // parent.postMessage({ message: 'decline' }, '*');
    redirectToDecline();
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <h1>Something went wrong.</h1>;
    }

    return this.props.children;
  }
}
